import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "poll",
  "use": "poll-usage",
  "viewBox": "0 0 29 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 20\" id=\"poll\">\n    <path d=\"M10.357 0c1.144 0 2.072.927 2.072 2.071V25.93a2.071 2.071 0 1 1-4.143 0V2.07C8.286.927 9.213 0 10.357 0zM2.071 16c1.144 0 2.072.927 2.072 2.071v7.858a2.071 2.071 0 0 1-4.143 0V18.07C0 16.927.927 16 2.071 16zm16.572-6c1.144 0 2.071.927 2.071 2.071V25.93a2.071 2.071 0 1 1-4.143 0V12.07c0-1.144.928-2.071 2.072-2.071z\" transform=\"rotate(90 14.429 14.071)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol